import type { ReadonlyDeep } from 'type-fest';

import { QuotationInput } from '@e-socna/data-layer';

import { codingConfigForm2ApiMapper } from '../../../forms/CodingConfig/mappers/coding-config.form2api.mapper';
import { pruneInput } from '../../../utils/prune-input.util';
import { recursiveSectionForm2ApiMapper } from '../../../components/DocumentEditor/mappers/recursive-section.form2api.mapper';

import type { MissionQuotationPage_OneQuotation } from '../hooks/useFindOneQuotationQuery.hook';

export function quotationForm2ApiMapper(
  quotation: ReadonlyDeep<MissionQuotationPage_OneQuotation>,
) {
  const quotationInput = pruneInput(quotation, QuotationInput);

  return {
    ...quotationInput,
    virtualRoot: recursiveSectionForm2ApiMapper(quotation.virtualRoot),
    codingConfig: codingConfigForm2ApiMapper(quotation.codingConfig),
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    templateId: quotation.templateId || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    title: quotation.title || null,
  };
}
